export default __webpack_public_path__ + "static/media/diamond.5e0de0c6.svg";